import React from 'react';
import solution from "../../images/solutions.png";

const HeroSection = () => {
  return (
    <div
      className="relative w-full xl:h-[599px] overflow-hidden"
      style={{
        background: 'linear-gradient(119.39deg, #0D924F 31.98%, rgba(0, 174, 217, 0.3) 119.02%)'
      }}
    >
      {/* Text Content */}
      <div
        className="relative xl:absolute text-white px-6 sm:px-10 lg:px-[60px] xl:px-0 pt-16 sm:pt-20 lg:pt-24 xl:pt-0 xl:left-[120px] xl:top-[calc(50%-114.5px)] xl:h-[228px] text-[28px] sm:text-[36px] md:text-[44px] lg:text-[52px] xl:text-[64px] leading-[1.2] xl:leading-[76px] font-normal"
      >
        Fuel your impact with <br/> <span className="font-bold"> CloseCarbon's <br/> sustainability solution</span>
      </div>

      {/* Image */}
      <img
        loading='lazy'
        src={solution}
        alt="Solution Hero"
        className="relative xl:absolute w-[80%] max-w-[320px] sm:max-w-[400px] xl:max-w-none xl:w-[500px] mx-auto xl:mx-0 my-10 xl:my-0 xl:left-[850px] xl:top-[70px] bg-cover  bg-center bg-no-repeat"
      />
    </div>
  );
};

export default HeroSection;